"use client";

import { useEffect } from "react";
import * as Sentry from "@sentry/nextjs";

/**
 * Top-level fallback for errors thrown in the root layout. Must render its own
 * <html>/<body> since it replaces the root layout when it fires.
 */
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    Sentry.captureException(error);
    console.error(error);
  }, [error]);

  return (
    <html lang="fr">
      <body className="flex min-h-dvh items-center justify-center bg-background p-8 text-foreground">
        <div className="mx-auto max-w-md rounded-xl border bg-card p-6 text-center">
          <h2 className="mb-1 text-lg font-semibold">Une erreur est survenue</h2>
          <p className="mb-4 text-sm text-muted-foreground">
            {error.message || "Impossible de charger l'application."}
          </p>
          <button
            type="button"
            onClick={() => reset()}
            className="inline-flex h-8 items-center justify-center rounded-lg border border-border bg-background px-3 text-sm font-medium hover:bg-muted"
          >
            Réessayer
          </button>
        </div>
      </body>
    </html>
  );
}
